<template>
  <div class="topicOne">
    <canvas width="500" height="500" ref="zt" style="width:100%;"></canvas>
    <div class="button">
      <div
        class="button-item"
        v-for="(item,index) in selectArr"
        :key="index"
        :class="index === 1 ? 'wrong': 'right'"
        @click.stop="confirmAns(item)"
        :style="{width: (1/selectArr.length)*100 +'%'}"
      >{{item}}</div>
      <!-- 左边为正确答案，右边为错误答案 -->
    </div>
  </div>
</template>

<script>
import Island from '../lib/island'

export default {
  name: 'topicOne',
  props: {
    question: {
      type: Object,
      default: null
    },
    reload: {
      type: Number
    }
  },
  watch: {
    reload() {
      this.initZT()
      this.selectArr = this.question.selector.split('||||')
    }
  },
  data() {
    return {
      selectArr: [] // 选择选项
    }
  },
  created() {
    this.selectArr = this.question.selector.split('||||')
  },
  mounted() {
    this.initZT()
  },
  methods: {
    initZT() {
      const { Practice } = Island
      // eslint-disable-next-line no-new
      if (this.p) {
        this.p.off()
      }
      this.p = new Practice({
        $el: this.$refs.zt, // canvas对象
        width: 500, // canvas宽度
        type: 1, // 0 执行题，1 判断题, 2 单选题，3 其他类型
        content: this.question.ask_desc // 内容
      })
    },
    // 获取答案正确与否
    confirmAns(item) {
      const answer = {
        desc: '', // 答案结果
        data: item // 学生的答案
      }
      if (item === this.question.answer) {
        answer.desc = '正确'
        this.$emit('getResult_judge', answer)
      } else {
        answer.desc = '错误'
        this.$emit('getResult_judge', answer)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.topicOne {
  width: 100%;
  height: 100%;

  canvas {
    width: 100%;
    display: block;
  }

  .answers {
    width: halvePx(670);
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    margin-top: halvePx(86);

    img {
      display: inline-block;
      width: halvePx(44);
      height: halvePx(60);
    }

    .answers-choose {
      height: auto;

      .choose-item {
        width: halvePx(540);
        height: halvePx(100);
        background: rgba(250, 229, 179, 1);
        border: halvePx(2) solid rgba(196, 178, 135, 1);
        border-radius: halvePx(50);
        margin: auto;
        font-size: halvePx(30);
        font-family: PingFang-SC-Regular;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: halvePx(100);
        text-align: center;
        margin: halvePx(20);
      }
    }
  }

  .button {
    display: flex;
    align-items: center;
    justify-content: center;

    .button-item {
      width: halvePx(200);
      height: halvePx(100);
      line-height: halvePx(100);
      text-align: center;
      border-radius: halvePx(50);
      margin: halvePx(20);
      font-size: halvePx(30);
      font-family: PingFang-SC-Regular;
      font-weight: 400;
      color: #fff;

      &.wrong {
        background: rgba(255, 175, 97, 1);
      }

      &.right {
        background: rgba(111, 218, 121, 1);
      }
    }
  }
}
</style>
